<mat-nav-list>
  <ng-container *ngFor="let option of options">
    <ng-container *ngIf="option.submenu && option.submenu.length > 0">
      <mat-expansion-panel [class.mat-elevation-z0]="true" class="dhl-menu-sidenav">
        <mat-expansion-panel-header>{{ option.menuName }}</mat-expansion-panel-header>
        <dhl-menu-item #menu [options]="option.submenu" (closeSidenav)="closeSidenav.emit()"></dhl-menu-item>
      </mat-expansion-panel>
    </ng-container>
    <ng-container *ngIf="!option.submenu || option.submenu.length === 0">
      <mat-list-item (click)="closeSidenav.emit()" [routerLink]="[option.url]" routerLinkActive="dhl-menu-active">
        {{ option.menuName }}
      </mat-list-item>
    </ng-container>
  </ng-container>
</mat-nav-list>
